<template>
  <div
    class="form__radio-wrapper">
    <input
      :id="id"
      :name="name"
      type="radio"
      class="form__radio"
      @click="$emit('selected', field, value)">
    <label
      :for="id"
      :value="label"
      class="form__option-label"
    >
      <span 
        :style="{ color: radioButtonColor }" 
        class="form__option-input form__option-input--radio"/>{{ label }}
    </label>
  </div>
</template>

<script>
// The radio button dot and border colors should match the button background
export default {
  name: "FieldRadio",
  props: {
    radioButtonColor: {
      type: String,
      default: "rgb(34,158,61)" // Default to the mockup green
    },
    field: {
      type: Object,
      required: true
    },
    id: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    name: {
      required: true,
      type: String
    },
    value: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "ConvoStyles/convo_master.scss"; // Allows us to use scss variables

input[type="radio"] {
  &:checked ~ label > .form__option-input--radio {
    background-color: currentColor;
    box-shadow: inset 0 0 0 0.15rem #fff;
  }
}
.form__option-input {
  border-radius: 50%;
}
</style>
